import React, { useState, useCallback, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { t } from 'i18next';
import { Input, Button } from 'components';
import {
  // CountryCode,
  Createlogin,
  MobileOtp,
  SendMailOtp,
  UpdateAuthData,
} from 'redux/features/LoginSlice';
// import Phoneinput from 'components/Phoneinput';
import { Divider, IconButton, InputAdornment } from '@mui/material';
import AutoComplete from 'components/AutoComplete';

import { ReactComponent as Visibility } from 'assert/images/Common/visibility.svg';
import { ReactComponent as VisibilityOff } from 'assert/images/Common/visibilityOff.svg';
import UserNameCreation from './UserNameCreation';
import { domainOptions } from 'utils/helper';
import { mailformat } from 'utils/Constant';
import { AuthContext } from 'router/AuthProvider';
import GoogleLogin from './GoogleLogin';
import AppleLogin from './AppleLogin';

const LoginAndSignup = ({ type, handleChange }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { recheckAuth } = useContext(AuthContext);

  const isSignUp = type === 'SignUp';

  const { authData } = useSelector((state) => state?.LoginReducer);

  const [show, setShow] = useState(false);
  const [isLoginUsingGoogle, setIsLoginUsingGoogle] = useState(false);
  const [inputChanges, setInputChanges] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [enableSubmit, setEnableSubmit] = useState(null);
  const [changeMobile, setChangeMobile] = useState(false);
  const [openUserNameComp, setOpenUserNameComp] = useState(false);
  const [loginDetails, setLoginDetails] = useState({
    type: 'email',
    email: '',
    password: '',
    phone: '',
    code: '',
    phcode: '',
    sid: '',
    otpType: isSignUp ? 'register' : '',
  });
  const [errMsg, setErrmsg] = useState({
    email: '',
    password: '',
    phone: '',
  });

  // useEffect(() => {
  //   // dispatch(CountryCode());
  //   !countryCode?.country_calling_code && dispatch(CountryCode());
  // }, []);

  // useEffect(() => {
  //   setLoginDetails((prevState) => ({
  //     ...prevState,
  //     code: countryCode?.country_calling_code?.replace('+', ''),
  //   }));
  // }, [countryCode]);

  useEffect(() => {
    const savedEmail = sessionStorage.getItem(
      isSignUp ? 'signUpEmail' : 'signInEmail'
    );
    const savedPassword = sessionStorage.getItem(
      isSignUp ? 'signUpPassword' : 'signInPassword'
    );
    setLoginDetails((prevState) => ({
      ...prevState,
      email: savedEmail || '',
      password: savedPassword || '',
    }));
  }, [isSignUp]);

  const handleChanges = useCallback((data, name) => {
    if (name === 'email') {
      sessionStorage.setItem(
        isSignUp ? 'signUpEmail' : 'signInEmail',
        data || ''
      );
    }
    if (name === 'password') {
      sessionStorage.setItem(
        isSignUp ? 'signUpPassword' : 'signInPassword',
        data?.replace(/\s/g, '') || ''
      );
    }
    setLoginDetails((prevState) => ({
      ...prevState,
      [name]: name === 'password' ? data?.replace(/\s/g, '') : data,
    }));
  }, []);

  const handleValidation = () => {
    const validationParams = { ...errMsg };

    if (!loginDetails.password) validationParams.password = t('Auth.passreq');
    else if (loginDetails.password.length < 6)
      validationParams.password = t('Auth.passsixreq');
    else validationParams.password = '';

    if (isSignUp) {
      if (!changeMobile && loginDetails.email === '') {
        validationParams.email = t('Auth.emailreq');
      } else if (
        !changeMobile &&
        loginDetails.email?.length >= 3 &&
        !mailformat.test(loginDetails.email)
      ) {
        validationParams.email = t('Auth.emailvalreq');
      } else validationParams.email = '';
    }

    if (changeMobile && !loginDetails.phone) {
      validationParams.phone = t('Auth.phnonereq');
    } else {
      validationParams.phone = '';
    }
    setErrmsg(validationParams);
  };

  const handleSubmit = useCallback(() => {
    setIsLoginUsingGoogle(false);
    handleValidation();
    setEnableSubmit(!enableSubmit);
  }, [enableSubmit, handleValidation]);

  const onRightLabel = () => {
    setLoginDetails((prevState) => ({
      ...prevState,
      type: changeMobile ? 'mobile' : 'email',
    }));
    setChangeMobile(!changeMobile);
  };
  useEffect(() => {
    if (authData?.success) {
      setIsLoading(false);
      dispatch(UpdateAuthData(''));
      if (isSignUp && !isLoginUsingGoogle) {
        handleChange('verification');
      } else {
        if (authData?.data?.hasUserName) {
          recheckAuth();
          navigate('/');
        } else {
          setOpenUserNameComp(true);
        }
      }
      if (authData?.data?.hasUserName) {
        sessionStorage.removeItem('signInEmail');
        sessionStorage.removeItem('signInPassword');
      }
    } else if (!authData?.success) {
      setIsLoading(false);
      dispatch(UpdateAuthData(''));
    }
  }, [authData]);

  useEffect(() => {
    if (enableSubmit !== null) {
      const validation = Object.keys(errMsg).every((it) => errMsg[it] === '');
      if (validation) {
        setIsLoading(true);
        if (isSignUp) {
          if (changeMobile) {
            // loginDetails.phcode = '+' + loginDetails.code + loginDetails.phone;
            dispatch(MobileOtp(loginDetails, true));
          } else {
            dispatch(SendMailOtp(loginDetails, true));
          }
        } else {
          dispatch(
            Createlogin(loginDetails, changeMobile ? 'mobile' : 'email')
          );
        }
      }
    }
  }, [enableSubmit]);

  const isFormValid = () => {
    const { phone, password, email } = loginDetails;
    if (changeMobile) {
      return phone && password?.length > 5;
    } else {
      return email?.length >= 3 && password?.length > 5;
    }
  };

  const handleInputChanges = (data, name) => {
    !data.includes('@') && setInputChanges(data);
    handleChanges(data, name);
  };

  if (openUserNameComp) {
    return <UserNameCreation handleChange={() => setOpenUserNameComp(false)} />;
  }

  return (
    <>
      <h1 className="card-title">
        {t(isSignUp ? 'Auth.SignUp' : 'Auth.SignIn')}
      </h1>
      <div className="inputbox">
        {!changeMobile && (
          <AutoComplete
            freeSolo
            Options={inputChanges ? domainOptions(inputChanges) : []}
            label={isSignUp ? t('Auth.Email') : t('Auth.EmailOrUsername')}
            value={loginDetails.email}
            onChange={(data) => handleChanges(data, 'email')}
            errMsg={errMsg.email}
            rightLabel={t(
              isSignUp ? 'Auth.SignUpToPhone' : 'Auth.LoginToPhone'
            )}
            onRightLabel={onRightLabel}
            onInputChange={(_, newInputValue) =>
              handleInputChanges(newInputValue, 'email')
            }
          />
        )}
        {/* {changeMobile && (
          <Phoneinput
            label={t('Auth.Phone')}
            value={loginDetails.phone}
            onChange={(data) => handleChanges(data, 'phone')}
            errMsg={errMsg.phone}
            rightLabel={t(
              isSignUp ? 'Auth.SignUpToEmail' : 'Auth.LoginToEmail'
            )}
            onRightLabel={onRightLabel}
            code={loginDetails.code}
            CodeChange={(data) => handleChanges(data, 'code')}
          />
        )} */}
        <Input
          label={t(isSignUp ? 'Auth.PasswordMax' : 'Auth.Password')}
          type={show ? 'text' : 'password'}
          value={loginDetails.password}
          onChange={(data) => handleChanges(data, 'password')}
          onKeyDown={(event) => {
            if (event?.key === 'Enter') {
              isFormValid() && handleSubmit();
            }
          }}
          errMsg={errMsg.password}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShow(!show)}
                edge="end"
              >
                {show ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
      </div>
      {!isSignUp && (
        <div className="align-end">
          <Link className="link-styles" to="/resetpassword">
            {t('Auth.Forgot')}
          </Link>
        </div>
      )}
      <Button
        label={t(isSignUp ? 'Auth.SignUp' : 'Auth.SignIn')}
        disabled={!isFormValid()}
        onClick={isFormValid() ? handleSubmit : () => {}}
        customStyles="auth-action-btn"
        loading={isLoading}
        loadingIndicator="Loading…"
      />
      <div className='auth-btn-wrapper'>
        <Divider>Or {isSignUp ?  'Sign Up With' : 'Sign In With'}</Divider>
        <div className="auth-social-btns">
          <GoogleLogin handleGoogleClick={() => setIsLoginUsingGoogle(true)} />
          <AppleLogin handleAppleClick={() => setIsLoginUsingGoogle(true)} />
        </div>
      </div>
      <div className="auth-footer">
        {t(isSignUp ? 'Auth.AlreadyHaveAccount' : 'Auth.DontHaveAccount')}
        <Link className="link-styles" to={isSignUp ? '/login' : '/signup'}>
          {t(isSignUp ? 'Auth.SignIn' : 'Auth.SignUp')}
        </Link>
      </div>
    </>
  );
};

export default LoginAndSignup;
